<template>
<div>
    <CapBlog/>
    <div class="container">
        <br><br><br><br>
        <h1>BLOG</h1>
        
        <div class="card mt-3" v-for="post in posts" v-bind:key="post.title">
            <!-- <img v-bind:src=" 'images/' + post.image " class="card-img-top" alt=""> -->
            <div class="card-body">
                <h5 class="card-title">{{ post.title }}</h5>
                <p class="card-text">{{ post.content }}</p>
                <!--<button  class="btn btn-success" v-on:click="postClick(post)">Veure resum...!</button>-->
                <router-link class="btn btn-primary" :to="{name: 'post', params: {id: post.id }}">Veure</router-link>
            </div>
        </div>

        <!--<modal-post @closeModalPost="closeModalPost" :post="postSelected"></modal-post>-->
       
    </div>

    <Peu/>

</div>
</template>

<script>
  export default {
        created() {
            this.getPost();
        },

        methods:{
            //Carregar els Post
            getPost() {
                fetch('/api/post')
                    .then( response => response.json())
                    .then( json => this.posts = json.data.data);
            },

            // Crida del Modal
            postClick: function(post) {
                // al canviar el contigut de postSelected, s'activa el Watch
                // de PostModalComponent.vue
                this.postSelected = post;
            },

            //Netejar el Modal quan es tanca        
            closeModalPost: function() {
               this.postSelected = "";
            }
        },
    
        data: function() {
            return {
                postSelected: "",
                posts: []
            }
        }

        
    }
</script>


